import React from 'react'
import './css/HomeAbout.css'
import Layer1 from './../assets/images/HomeAbout1.jpg'
import Layer2 from './../assets/images/HomeAbout2.jpg'
import { Link } from 'react-router-dom'

function HomeAbout() {
    return (
        <div className='HomeAbout'>
            <div className='left'>
                <div className='image'>
                    <img src={Layer1} alt='Layer 1' />
                </div>
                <div className='image'>
                    <img src={Layer2} alt='Layer 2' />
                </div>
            </div>
            <div className='right'>
                <h1>Delightful<br />Experiences</h1>
                <p>Step into Plaza Catering, where unforgettable moments await! Treat yourself to our mouthwatering dishes carefully crafted with expertise. Immerse yourself in an atmosphere of sophistication and allure. Experience the best catering services in Kerala combining exceptional Flavors, impeccable cleanliness and seamless efficiency all delivered at incredible affordability. Our utmost delight lies, in your satisfaction. So why wait? Savor the pure bliss!
                </p>
                <Link to="/about"><button>About Us</button></Link>
            </div>
        </div>
    )
}

export default HomeAbout